import { render, staticRenderFns } from "./Income-Index.vue?vue&type=template&id=514d307a&"
import script from "./Income-Index.vue?vue&type=script&lang=js&"
export * from "./Income-Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports